import React from 'react';
import { Check, Shield, ArrowRight } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function PricingSection() {
  return <section id="pricing" className="py-24 md:py-32 bg-cream-50 relative" data-id="element-106">
      <div className="max-w-4xl mx-auto px-4" data-id="element-107">
        <FadeIn data-id="element-108">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-sage-100" data-id="element-109">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-110">
              {/* Left Side: Value Stack */}
              <div className="p-8 md:p-12 bg-sage-50/50" data-id="element-111">
                <h3 className="font-serif text-3xl text-warm-900 mb-4" data-id="element-112">
                  ¿Qué incluye exactamente?
                </h3>
                <p className="text-warm-600 mb-6" data-id="element-113">
                  Al hacer tu compra, recibes acceso inmediato a:
                </p>

                {/* Main PDF */}
                <div className="mb-6" data-id="element-114">
                  <h4 className="font-serif text-lg text-warm-900 font-semibold mb-3" data-id="element-115">
                    📄 El PDF completo: "Protocolo Cuero Cabelludo en Calma (14
                    días)"
                  </h4>
                  <p className="text-warm-600 text-sm mb-3" data-id="element-116">
                    Un plan paso a paso para bajar la irritación, el quiebre y
                    el pánico en la regadera. Incluye:
                  </p>
                  <ul className="space-y-3" data-id="element-117">
                    {['El Test de Señal Dominante (grasa, ardor, descamación) para personalizar tu plan.', 'La Triada 3×3: 3 señales → 3 acciones (limpiar, resetear, estimular) con tiempos claros.', 'Técnica de lavado correcta y frecuencia ideal según tu señal.', 'El calendario completo de 14 días: qué hacer cada día y cómo actuar si un día notas más caída.', 'La rutina mínima de 7 minutos para mantener control sin recaer.', 'FAQ y Glosario: respuestas claras a dudas comunes.'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-118">
                        <div className="bg-sage-200 p-1 rounded-full mt-0.5 flex-shrink-0" data-id="element-119">
                          <Check className="w-3 h-3 text-sage-700" data-id="element-120" />
                        </div>
                        <span className="text-warm-700 text-sm" data-id="element-121">{item}</span>
                      </li>)}
                  </ul>
                </div>

                {/* Bonuses */}
                <div className="mb-6 p-4 bg-white/60 rounded-xl border border-sage-200/50" data-id="element-122">
                  <h4 className="font-serif text-lg text-warm-900 font-semibold mb-3" data-id="element-123">
                    🎁 Bonos incluidos con tu compra:
                  </h4>
                  <ul className="space-y-3" data-id="element-124">
                    <li className="flex items-start gap-3" data-id="element-125">
                      <div className="bg-sage-200 p-1 rounded-full mt-0.5 flex-shrink-0" data-id="element-126">
                        <Check className="w-3 h-3 text-sage-700" data-id="element-127" />
                      </div>
                      <div data-id="element-128">
                        <span className="text-warm-800 text-sm font-medium" data-id="element-129">
                          Checklist "Mi ducha no me roba el pelo"
                        </span>
                        <p className="text-warm-600 text-xs mt-0.5" data-id="element-130">
                          Lista imprimible con los pasos clave en cada lavado,
                          para seguir la técnica sin esfuerzo.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start gap-3" data-id="element-131">
                      <div className="bg-sage-200 p-1 rounded-full mt-0.5 flex-shrink-0" data-id="element-132">
                        <Check className="w-3 h-3 text-sage-700" data-id="element-133" />
                      </div>
                      <div data-id="element-134">
                        <span className="text-warm-800 text-sm font-medium" data-id="element-135">
                          Tracker 14 días "Mi registro de cuero cabelludo"
                        </span>
                        <p className="text-warm-600 text-xs mt-0.5" data-id="element-136">
                          Plantilla diaria para medir picor, grasa, descamación,
                          estrés y sueño, y así detectar patrones.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className="flex items-center gap-3 p-4 bg-sage-100/50 rounded-xl border border-sage-200/50" data-id="element-137">
                  <Shield className="w-8 h-8 text-sage-600 flex-shrink-0" data-id="element-138" />
                  <div data-id="element-139">
                    <p className="font-bold text-sage-800 text-sm" data-id="element-140">
                      Garantía de 30 días
                    </p>
                    <p className="text-xs text-sage-700" data-id="element-141">
                      Si no sientes alivio, te devolvemos el 100%.
                    </p>
                  </div>
                </div>
              </div>

              {/* Right Side: Price & CTA */}
              <div className="p-8 md:p-12 flex flex-col justify-center bg-white relative" data-id="element-142">
                <div className="text-center" data-id="element-143">
                  {/* Product Image */}
                  <div className="mb-6" data-id="element-144">
                    <img src="https://cdn.magicpatterns.com/uploads/weGiYHTGF1DpAXRgWwf8N6/imagen_prodct.png" alt="Protocolo Cuero Cabelludo en Calma - Vista previa del producto" className="w-48 h-auto mx-auto rounded-xl shadow-md" data-id="element-145" />
                  </div>

                  <p className="text-sage-600 font-medium uppercase tracking-wider text-sm mb-2" data-id="element-146">
                    Oferta Especial
                  </p>
                  <div className="flex items-center justify-center gap-2 mb-2" data-id="element-147">
                    <span className="text-gray-400 line-through text-xl" data-id="element-148">
                      $12.99 USD
                    </span>
                    <span className="text-5xl md:text-6xl font-serif text-warm-900" data-id="element-149">
                      $6.35
                    </span>
                  </div>
                  <p className="text-warm-500 text-sm mb-8" data-id="element-150">
                    Pago único en USD. Acceso inmediato.
                  </p>

                  <a href="https://www.factoravance.com/cart/51517081354560:1" target="_blank" rel="noopener noreferrer" className="w-full bg-sage-500 hover:bg-sage-600 text-white text-lg font-medium px-8 py-4 rounded-full transition-all duration-300 shadow-lg shadow-sage-200 hover:shadow-sage-300 flex items-center justify-center gap-2 group" data-id="element-151">
                    Comenzar ahora
                    <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-152" />
                  </a>

                  <p className="mt-4 text-xs text-gray-400" data-id="element-153">
                    Pago seguro con tarjeta o PayPal. <br data-id="element-154" />
                    Entrega digital inmediata a tu email.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}